import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';

import { PagedTable } from '../../common';
import {
    Portlet,
    PortletBody,
    PortletHeader
} from "../../partials/content/Portlet";

const DEFAULT_SORT = [{ id: 'payerName', direction: 'asc' }];

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    button: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },

    icon: {
        fontSize: 17,
        marginTop: 1,
    },
    filterFormControl: {
        margin: theme.spacing(1),
        minWidth: 100,
        maxWidth: 150,
    },
}));

export default function PayerStatisticsPage({
    intl,
    tab, payerListPending, payerData, remitPayerData, payerFields, remitPayerFields, payerContracts, userRole,
    stlErrorsPending,
    clientFilesData,
    clientFilesFields,clients,
    stlErrorsData,
    stlErrorFields,
    clientFilesPending,
    selectedClient,
    claimProviderData,
    remitProviderData,
    claimProviderFields,
    remitProviderFields,
    claimProviderPending,
    remitProviderPending,
    actions: {
        payersStatsLanding,
        clientFilesStatsLanding,
        stlLoadErrorsLanding,
        remitPayersStatsLanding,
        searchGetByName,
        searchReset,
        resetPagedTable,
        claimProviderStatsLanding,
        remitProviderStatsLanding
    }
}) {
    const [refresh, setRefresh] = useState(Promise.resolve());
    const [remitRefresh, setRemitRefresh] = useState(Promise.resolve());
    const [clientFilesRefresh, setClientFilesRefresh] = useState(Promise.resolve());
    const [clientId, setClientId] = useState(null);
    const [claimProviderRefresh, setClaimProviderRefresh] = useState(Promise.resolve());
    const [remitProviderRefresh, setRemitProviderRefresh] = useState(Promise.resolve());


    const classes = useStyles();

    useEffect(() => {
        let pageName = {
            name: 'payers-stats-landing'
        }
        searchGetByName(pageName);

        return function cleanup() {
            searchReset();
            resetPagedTable(pageName.name);
        }
    }, [searchGetByName]);

    useEffect(() => {
        let pageName = {
            name: 'remit-payers-stats-landing'
        }
        searchGetByName(pageName);

        return function cleanup() {
            searchReset();
            resetPagedTable(pageName.name);
        }
    }, [searchGetByName]);

    useEffect(() => {
        if (tab === 4 && clientId) {
            setClientFilesRefresh(Promise.resolve())
        }
    }, [clientId]);

    useEffect(() => {
        const pageName = { name: 'claim-provider-stats-landing' };
        searchGetByName(pageName);
        return () => {
            searchReset();
            resetPagedTable(pageName.name);
        };
    }, [searchGetByName]);

    useEffect(() => {
        const pageName = { name: 'remit-provider-stats-landing' };
        searchGetByName(pageName);
        return () => {
            searchReset();
            resetPagedTable(pageName.name);
        };
    }, [searchGetByName]);


    function handleLoad(sort, filter, pagination) {
        payersStatsLanding(pagination, sort, filter);
    }

    function handleRemitLoad(sort, filter, pagination) {
        remitPayersStatsLanding(pagination, sort, filter);
    }

    function handleClientFilesLoad(sort, filter, pagination) {
        clientFilesStatsLanding(pagination, sort, filter,clientId || selectedClient);
    }

    function handleStlErrorsLoad(sort, filter, pagination) {
        stlLoadErrorsLanding(pagination, sort, filter,clientId || selectedClient);
    }

    function handleClaimProviderLoad(sort, filter, pagination) {
        claimProviderStatsLanding(pagination, sort, filter);
    }

    function handleRemitProviderLoad(sort, filter, pagination) {
        remitProviderStatsLanding(pagination, sort, filter);
    }


    function handleRefresh() {
        setRefresh(Promise.resolve());
    }

    function handleRemitRefresh() {
        setRemitRefresh(Promise.resolve());
    }
    function handleClientFilesRefresh() {
        setClientFilesRefresh(Promise.resolve());
    }

    const handleFilterChange = (e) => {
        setClientId(e.target.value)
    }

    return (
        <>
            <Helmet title="Payers Statistics" />
            <Portlet>
                <PortletHeader
                    title="Statistics"
                    name={
                        tab === 1
                            ? "payers-stats-landing"
                            : tab === 4 ? "client-files-stats-landing" 
                            : tab===5? "stl-load-errors-landing"
                            : tab === 7 ? "claim-provider-stats-landing"
                            : tab === 8 ? "remit-provider-stats-landing"
                            :"remit-payers-stats-landing"
                    }
                    includeAdvanceFilters={tab === 4}
                    toolbar={
                        tab === 4 ? (
                            <Grid>
                                <FormControl
                                    className={classes.filterFormControl}
                                >
                                    <InputLabel>Client</InputLabel>
                                    <Select
                                        value={
                                            clientId ||
                                            selectedClient
                                        }
                                        onChange={handleFilterChange}
                                        name="clientId"
                                    >
                                        {clients.map((client) => (
                                            <MenuItem
                                                key={client.clientId}
                                                value={client.clientId}
                                            >
                                                {client.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        ) : undefined
                    }
                />
                <PortletBody>
                    {tab === 1 && (
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <PagedTable
                                        name="payers-stats-landing"
                                        fields={payerFields}
                                        data={payerData}
                                        onLoad={handleLoad}
                                        refresh={refresh}
                                        defaultSort={DEFAULT_SORT}
                                        title="Claim Payer Stats"
                                        tableLevelLoading={payerListPending}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {tab === 2 && (
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <PagedTable
                                        name="remit-payers-stats-landing"
                                        fields={remitPayerFields}
                                        data={remitPayerData}
                                        onLoad={handleRemitLoad}
                                        refresh={remitRefresh}
                                        defaultSort={DEFAULT_SORT}
                                        title="Remit Payer Stats"
                                        tableLevelLoading={payerListPending}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {tab === 4 && (
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <PagedTable
                                        name="client-files-stats-landing"
                                        fields={clientFilesFields}
                                        data={clientFilesData}
                                        onLoad={handleClientFilesLoad}
                                        refresh={clientFilesRefresh}
                                        defaultSort={[]}
                                        title="Failed Files Stats"
                                        tableLevelLoading={clientFilesPending}
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {tab === 5 && (
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <PagedTable
                                        name="stl-load-errors-landing"
                                        fields={stlErrorFields}
                                        data={stlErrorsData}
                                        onLoad={handleStlErrorsLoad}
                                        refresh={clientFilesRefresh}
                                        defaultSort={[]}
                                        title="Load Errors"
                                        tableLevelLoading={stlErrorsPending}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {tab === 7 && (
                        <div className="row">
                            <div className="col-md-12">
                                <PagedTable
                                    name="claim-provider-stats-landing"
                                    fields={claimProviderFields}
                                    data={claimProviderData}
                                    onLoad={handleClaimProviderLoad}
                                    refresh={claimProviderRefresh}
                                    defaultSort={[{ id: 'providerName', direction: 'asc' }]}
                                    title="Claim Provider Stats"
                                    tableLevelLoading={claimProviderPending}
                                />
                            </div>
                        </div>
                    )}
                    {tab === 8 && (
                        <div className="row">
                            <div className="col-md-12">
                                <PagedTable
                                    name="remit-provider-stats-landing"
                                    fields={remitProviderFields}
                                    data={remitProviderData}
                                    onLoad={handleRemitProviderLoad}
                                    refresh={remitProviderRefresh}
                                    defaultSort={[{ id: 'providerName', direction: 'asc' }]}
                                    title="Remit Provider Stats"
                                    tableLevelLoading={remitProviderPending}
                                />
                            </div>
                        </div>
                    )}
                </PortletBody>
            </Portlet>
        </>
    );
}